module.exports = __webpack_public_path__ + "static/media/Tips_para_elegir_tu_primer_auto.ed8dcae3.pdf";